import { FC } from 'react';
import { Roadservice } from './Roadservice/Roadservice';

export const RoadservicePage: FC = () => {
  return <Roadservice />;
};
